import React, { useState, useEffect } from 'react';

const Toast = ({ message, duration = 2800 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), duration);
      return () => clearTimeout(timer);
    }
  }, [message, duration]);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '24px',
      right: '24px',
      background: 'var(--accent2)',
      color: '#000',
      padding: '12px 20px',
      borderRadius: '8px',
      fontSize: '13px',
      fontWeight: 600,
      zIndex: 9999,
      transform: 'translateY(0)',
      opacity: 1,
      transition: '0.3s'
    }}>
      {message}
    </div>
  );
};

export default Toast;